import React, { Component } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './index.scss';
import intl from 'react-intl-universal';

class Loading extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        const ariaLoading = intl.formatMessage({id: 'AriaLoading'});
        return (
            <div className={`loading${this.props.center?' center':''}`} role="status" aria-live="polite" aria-label={ariaLoading}>
                <Spin indicator={<LoadingOutlined className="loadingIcon" style={{ fontSize: 24 }} spin />} />
            </div>
        )
    }
}

export default Loading;
